var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"injury_grade"},_vm._l((_vm.gradeList),function(item,index){return _c('div',{key:index,staticClass:"injury_grade_item",style:(`width: ${index == _vm.gradeNum ? '18px' : '14px'};
              height:${index == _vm.gradeNum ? '18px' : '4px'};
              background: linear-gradient(to right, ${item[0]}, ${item[1]});
              transform: skew(-10deg);
          `)},[(index == _vm.gradeNum)?_c('span',{staticClass:"item_title"},[_vm._v(_vm._s(_vm.grade))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }